import { useState } from 'react';

import { MDText } from 'i18n-react';

import { IconText, VerifiedIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';

import { useSaleDetailsSub } from '../../../vehicleCollection/hooks/useSaleDetailsSub';
import { DealershipDetailsModal } from '../DealershipDetailsModal/DealershipDetailsModal';

import Texts from './DealerDetailsSidePanelRow.texts.json';

import styles from './DealerDetailsSidePanelRow.scss';

const LocalT = new MDText(Texts);

export const DealerDetailsSidePanelRow = () => {
  const {
    dealershipName,
    dealershipPhone,
    email,
  } = useSaleDetailsSub();

  const [openModal, setOpenModal] = useState<boolean>(false);

  if (!dealershipName) {
    return null;
  }

  const onOpenModal = () => {
    setOpenModal(true);

    POST_SALE_SNOW_PLOW_EVENTS.VIEW_DEALERS_DETAILS_MODAL_OPENED();
  };

  const onCloseModal = () => {
    setOpenModal(false);

    POST_SALE_SNOW_PLOW_EVENTS.VIEW_SALE_DETAILS_MODAL_CLOSED();
  };

  const dealerLinkContent = <div>
    {LocalT.translate('purchasedBy', {
      dealerName: <Hyperlink
        label={dealershipName}
        onClick={onOpenModal}
        variant="secondary"
      />,
    })}
  </div>;

  return (
    <li className={styles.detailDetailsSidePanelRow}>
      <span className={styles.iconTextWrapper}>
        <IconText
          icon={VerifiedIcon}
          text={dealerLinkContent}
          variant="small--regular"
        />
      </span>
      {openModal && (
        <DealershipDetailsModal
          dealership={{ contactEmail: email, contactNumber: dealershipPhone, name: dealershipName }}
          onCloseModalClick={onCloseModal}
        />
      )}
    </li>
  );
};
